// src/components/TaskUploadForm.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadTasksCsv } from '../features/tasks/taskSlice';

const TaskUploadForm = () => {
    const [file, setFile] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    const dispatch = useDispatch();
    const { isLoading, isError, message } = useSelector(state => state.tasks);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const droppedFile = e.dataTransfer.files[0];
            if (droppedFile.name.endsWith('.csv')) {
                setFile(droppedFile);
            } else {
                alert('Please upload a CSV file');
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!file) {
            alert('Please select a CSV file');
            return;
        }

        if (!file.name.endsWith('.csv')) {
            alert('Please upload a CSV file');
            return;
        }

        dispatch(uploadTasksCsv(file));
    };

    const downloadSampleCsv = () => {
        const sampleCsv = `title,description,assignee,due_date
Fix login bug,Users cannot login with special characters in password,John Smith,2025-01-15
Add dark mode,Implement dark theme for better user experience,Sarah Johnson,2025-01-20
Database optimization,Optimize slow queries for better performance,Mike Chen,2025-01-10`;

        const blob = new Blob([sampleCsv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sample_tasks.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className="task-upload-form">
            <h2>Upload Tasks CSV</h2>

            <form onSubmit={handleSubmit}>
                <div className={`file-upload-area ${dragActive ? 'drag-active' : ''}`}
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}>

                    <input
                        type="file"
                        id="csvFile"
                        accept=".csv"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />

                    <label htmlFor="csvFile" className="file-upload-label">
                        <div className="upload-content">
                            <div className="upload-icon">📄</div>
                            {file ? (
                                <div>
                                    <p><strong>Selected:</strong> {file.name}</p>
                                    <p>Click to change or drag another file</p>
                                </div>
                            ) : (
                                <div>
                                    <p><strong>Click to upload</strong> or drag and drop</p>
                                    <p>CSV files only</p>
                                </div>
                            )}
                        </div>
                    </label>
                </div>

                <div className="form-help">
                    <p>CSV should contain columns: <strong>title, description, assignee, due_date</strong></p>
                    <button type="button" onClick={downloadSampleCsv} className="btn-link">
                        Download sample CSV template
                    </button>
                </div>

                {isError && <div className="error-message">{message}</div>}

                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading || !file}
                >
                    {isLoading ? 'Analyzing...' : 'Upload & Analyze'}
                </button>
            </form>
        </div>
    );
};

export default TaskUploadForm;